
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/[resource_id]",
      function () {
        return require("private-next-pages/[publicId]/[resource_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/[resource_id]"])
      });
    }
  